import { useEffect, useRef } from "react";
import { useScopedPathname } from "@-/com.npmjs.expo-router";
import { useIsFocused } from "@-/com.npmjs.expo-router/react-navigation";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { useVoiceStudyHasTurn } from "@-/dev.improve.haniverse.lib.voice-study";
import { useLearnCardActionController } from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.card-action";
import useLatest from "@-/com.npmjs.use-latest";

/**
 * Selecting Voice outside a review starts the first eligible due card immediately. Mounted only by
 * the active Voice pill, so a session is active for exactly this component's lifetime: the next
 * session remounts it, which re-arms the one-shot start.
 */
export function VoiceStudyStart() {
  const focused = useIsFocused();
  const pathname = useScopedPathname("/learn");
  const hasTurn = useVoiceStudyHasTurn();
  const activated = useRef(false);
  const controller = useLearnCardActionController();
  // Navigation only — no card is being rated, so nothing is deprioritised.
  const startMutation = useMutation({
    mutationFn: () =>
      controller.advance({ mode: "replace", origin: { grapheme: "", kind: "review" } }),
    mutationKey: ["voiceStudyStart"],
  });
  const next = useLatest(startMutation);
  useEffect(() => {
    if (!focused || activated.current) {
      return;
    }
    activated.current = true;
    // The drill owns eligibility changes on an already-open front.
    if (pathname.includes("/deck")) {
      return;
    }
    if (!hasTurn || !pathname.includes("/review/")) {
      next.current.mutate();
    }
  }, [focused, pathname, next, hasTurn]);
  return null;
}
